import src from "IMAGE";
export default { src, width: 1010, height: 213, blurWidth: 0, blurHeight: 0};
